// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"wba-z","subtitle":"xba-z","wrapper":"yba-z","leftArrow":"zba-z","rightArrow":"Aba-z"};